import WorkstationAvailability from "app/models/workstationAvailability"
import { Action, Types } from "./templateWorkstationAvailabilities.actions"

export type TemplateWorkstationAvailabilitiesState = {
  errors: {}
  loading: boolean
  data: WorkstationAvailability[]
}

const initialState: TemplateWorkstationAvailabilitiesState = {
  data: [],
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): TemplateWorkstationAvailabilitiesState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
